import * as React from 'react'
import {Chosen, onChangeHandler} from "../../lib/sbhtml/chosen";
import {flattenCategoryTree} from "../../lib/category-manager/utils";
import {Option} from "react-select";
import {Checkbox} from "../../lib/sbhtml/checkbox";
import {toString, toStrings} from "../../lib/utils";
import {CategoryId, CategoryTreeItem, FlatCategoryTreeItem} from "../../lib/category-manager/data";
import {Query, QueryId} from "./data";

export type QueriesWidgetProps = ValueProps & CallbackProps

export type ValueProps = {
	categories: CategoryTreeItem[]
	selectedCategories: (number|string)[]
	queries: Query[]
	selectedQueries: (number|string)[]
}

type QueryToggle = (query: QueryId) => void
export type CallbackProps = {
	setCategoryFilters: (categories: CategoryId[]) => void
	setQueryCheckbox: QueryToggle
	unsetQueryCheckbox: QueryToggle
}

export const QueriesWidget = (props: QueriesWidgetProps) => {
	const flatCategories = flattenCategoryTree(props.categories)
	const options = mapCategoriesToOptions(flatCategories, props.selectedCategories)

	return <div>
		{props.categories.length > 0 && <Chosen
			multi={true}
			removeSelected={false}
			value={props.selectedCategories}
			options={options}
			onChange={onChangeHandler(props.setCategoryFilters)}
			placeholder="Filter unselected queries by category..."
		/>}
		{props.queries.length > 0 && <Queries {...props}/>}
	</div>
}

const mapCategoriesToOptions = (flatCats: FlatCategoryTreeItem[], selectedCategories: (number|string)[]):Option<number|string>[] => {
	return flatCats.map((fcti: FlatCategoryTreeItem) => {
		return {
			value: fcti.categorySerial,
			label: (fcti.depth > 0 ? " .... ".repeat(fcti.depth) : '')  + fcti.title,
			disabled: selectedCategories.find((sc) => sc == fcti.categorySerial) !== undefined
		}
	});
}

const Queries = (props: QueriesWidgetProps) => {
	return <div>
		<input
			hidden={true}
			readOnly={true}
			name="selectedQueries"
			key="selectedQueries"
			value={toStrings(props.selectedQueries).join()}
		/>
		<ul style={{listStyleType: "none", padding: 0}}>
			{props.queries.map((q:Query) => {
				const queryId = q.id
				const checked = props.selectedQueries.find((sq) => sq == queryId) !== undefined

				const arr1: (false|string|JSX.Element)[] = [
					q.instance != '' && (q.instance + ": "),
					q.title
				]
				const label: (false|string|JSX.Element)[] = arr1.concat(q.owner != '' ? [" (Owner: ", <strong key={"owner-" + queryId}>{q.owner}</strong>, ")"] : [])

				return <li key={queryId}><Checkbox
					name="queryid_array[]"
					value={toString(queryId)}
					label={label}
					checked={checked}
					onChange={() => (checked ? props.unsetQueryCheckbox : props.setQueryCheckbox)(queryId)}
				/></li>
			})}
		</ul>
	</div>
}



// WEBPACK FOOTER //
// ./src/communications/queries-widget/presentation.tsx